import {API_URL} from "../../../Constants";

export const countriesWithOrgs = () => {
    return `${API_URL}/countries/withOrgs`;
}

export const statesWithOrgs = () => {
    return `${API_URL}/state/withOrgs`;
}